import React from 'react'
import ReactGA from 'react-ga'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { doGetDependants, setIsAddingAccess } from '../actions/auth'
import Footer from '../components/footer'
import Loading from '../components/loading'
import NavBar from '../components/navbar'
import ParentalAccessInfo from '../components/parentalAccessInfo'
import ParentalAccessResultsBox from '../components/parentalAccessResultsBox'
import UserCard from '../components/usercard'
import TermsOfUseLink from '../components/termsOfUseLink'
class NewHomePage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: true,
            modalOpenTime: 0
        }
    }

    componentDidMount() {
        if(this.props.isAddingAccess === true){
            this.props.dispatch(setIsAddingAccess(false));
        }
        this.props.dispatch(doGetDependants())
            .then((resp) => {
                console.log("New dependant list generated.");
            });
        if (this.props.labResults === null) {
            // Not hooked up to a real api so commented out
            //this.props.dispatch(fetchLabResultsThunk());
        }
        if(this.state.showModal){
            var d = new Date();
            this.setState({modalOpenTime: d.getTime()})
        }
    }

    uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
          return v.toString(16);
        });
      }

    recordModalViewTime(){
        var modalCloseTime = new Date();
        var modalViewTime =  modalCloseTime.getTime() - this.state.modalOpenTime;
        
        console.log('Modal was open: ' +  modalViewTime + 'ms');
        ReactGA.event({
            category: 'User timing',
            action: 'Time spent on popup (ms)',
            label: this.uuidv4(),
            value: modalViewTime
          });
    }

    renderUser() {
        if (this.props.user == null) {
            return null;
        } else {
            return <UserCard user={this.props.user} language={this.props.language}/>
        }
    }

    render() {
        if (this.props.isError === true) {
            return <Redirect to="error" />
        }
        // FIXME Remove fake login!!!
        if (this.props.isLoggedIn !== true && this.props.isFakeLoggedIn !== true && this.props.isAddingAccess !== true && this.props.isLoggingOut !== true) {
            return <Redirect to="/" />
        }
        if (this.props.isLoadingLogin === true || this.props.isLoadingLabResults === true || this.props.isLoadingDependantList === true ||this.props.isLoggingOut === true) {
            return <Loading />
        }
        let parentalAccessBlurb;
        if (this.props.user === undefined || this.props.user === null) {
            parentalAccessBlurb = null;
        } else if (this.props.user.accessLevel === "1") {
            parentalAccessBlurb = <ParentalAccessInfo isModal={false} isResults={false} />;
        }

        // HTML here with bootstrap styles..
        return (
            <div className="container-full">
                <NavBar language={this.props.language}/>
                <div className="container">
                    <div className="col" id="first">
                        <div className="row">
                            <div className="col-12 col-lg-4 col-md-12 order-1 order-sm-1 order-md-1 order-lg-2">
                                {this.renderUser()}
                                <TermsOfUseLink />
                                {parentalAccessBlurb}
                            </div>
                            <ParentalAccessResultsBox user={this.props.user}/>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        isLoadingLabResults: state.api.isLoadingLabResults,
        isLoadingUsers: state.api.isLoadingUsers,
        isLoadingRegister: state.api.isLoadingRegister,
        isLoadingDependantList: state.auth.isLoadingDependantList,
        user: state.api.user,
        labResults: state.api.labResults,
        strings: state.language.strings,
        language: state.language.language,
        isLoggedIn: state.auth.isLoggedIn,
        isFakeLoggedIn: state.auth.isFakeLoggedIn,
        isError: state.api.isError,
        isAddingAccess: state.auth.isAddingAccess,
        isLoggingOut: state.auth.isLoggingOut,
    }
}

const ConnectedNewMainScreen = connect(
    mapStateToProps
)(NewHomePage);
export default ConnectedNewMainScreen;
